import React, { useState } from "react";
import TextField from "../../../components/Input/TextField";
import EditableContent from "../../../components/Input/EditableContent";
import { MdDelete } from "react-icons/md";
import { BsPlus } from "react-icons/bs";
import { LuArrowBigRightDash } from "react-icons/lu";
import ImageInput from "../../../components/Input/ImageInput";
import bosses from "../../../api/BossApi.json";

const bossList = Object.values(bosses).map((b) => b.name);
const IMG_URL = process.env.REACT_APP_IMG_URL;

const BossUpdatesInput = ({
  patch,
  section,
  i,
  handleSectionChange,
  handleImageUpload,
  handleRowChange,
  removeRow,
  addRow,
  deleteTable,
  addTable,
  removeSection,
}) => {
  const [open, setOpen] = useState(false);

  const filtered = bossList.filter((b) =>
    b.toLowerCase().includes(section.title?.toLowerCase()),
  );

  function handleBossSelect(i, bossName) {
  const selectedBoss = Object.values(bosses).find(b => b.name === bossName);
  if (selectedBoss) {
    handleSectionChange(i, "title", selectedBoss.name);
    handleSectionChange(i, "thumbnail", ["/uploads/1_boss/" +selectedBoss.img]);
  } else {
    handleSectionChange(i, "title", bossName);
    handleSectionChange(i, "thumbnail", []);
  }
}

  section.table.columns = ["", "", ""];
  return (
    <div>
      <span className="flex mb-4 mx-1 font-bold">
        {i + 1 + ". Bölüm: Boss Güncellemesi"}
      </span>
      <div className="grid grid-cols-[auto_1fr] gap-4 items-start">
        <div className="w-max">
          {section.thumbnail && section.thumbnail[0] ? (
            <div className="flex flex-col items-start gap-2">
              <img
                src={
                  section.thumbnail[0]?.includes("uploads")
                    ? IMG_URL + section.thumbnail[0]
                    : section.thumbnail[0]
                }
                alt="Thumbnail"
                className="max-h-64 max-w-auto rounded border"
              />
              <button
                type="button"
                onClick={() => handleSectionChange(i, "thumbnail", [])}
                className="bg-red-600 text-white px-3 py-1 rounded text-sm"
              >
                Thumbnailı Sil
              </button>
            </div>
          ) : (
            <ImageInput
              text={"📂 Boss Fotoğrafı Yükle"}
              onChange={(e) => handleImageUpload(e, i, "thumbnail")}
            />
          )}
        </div>

        <div className="min-w-0">
          <div className="relative">
            <input
              type="text"
              list="bosses"
              placeholder="Boss Adı"
              value={section.title}
              onChange={(e) => handleBossSelect(i, e.target.value)}
              onFocus={() => setOpen(true)}
              onBlur={() => setTimeout(() => setOpen(false), 100)}
              className="input focus:border-none w-full"
            />

            {open && filtered.length > 0 && (
              <ul className="absolute z-10 w-full bg-gray-800 border rounded-md shadow-lg max-h-64 overflow-auto">
                {filtered.map((boss, idx) => (
                  <li
                    key={idx}
                    onMouseDown={() => {handleBossSelect(i, boss); setOpen(false)}}
                    className="p-2 cursor-pointer hover:bg-gray-700"
                  >
                    {boss}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <EditableContent
            placeholder="Güncelleme açıklaması"
            patchNo={patch.yamaVersiyonu}
            value={section.content}
            onChange={(html) => handleSectionChange(i, "content", html)}
            className=" p-2 mb-1 border"
          />
        </div>
        <div className="col-span-3">
          {section.table.columns.length > 0 && (
            <div className="p-2 mb-2 rounded">
              {section.table.rows.map((row, rIndex) => (
                <div key={rIndex} className="flex mb-1">
                  {row.map((cell, cIndex) => (  
                    <div key={cIndex} className="flex">
                      <TextField
                        key={cIndex}
                        label={
                          cIndex === 0
                            ? "Özellik"
                            : cIndex === 1
                            ? "Eski Değer"
                            : "Yeni Değer"
                        }
                        placeholder="Veri"
                        value={cell}
                        onChange={(e) =>
                          handleRowChange(i, rIndex, cIndex, e.target.value)
                        }
                        className="p-2 border"
                      />
                      {cIndex === 1 && (
                        <div className="w-max h-max text-4xl self-center mx-2">
                          <LuArrowBigRightDash />
                        </div>
                      )}
                      {cIndex === 0 && (
                        <div className="w-max h-max text-4xl self-center mx-2">
                          :
                        </div>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => removeRow(i, rIndex)}
                    className="bg-red-600 mt-5 btn ml-4 text-white flex rounded items-center px-3"
                  >
                    <MdDelete className="text-white" />
                    Satırı Sil
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => addRow(i)}
                className="bg-green-600 items-center text-white rounded flex mx-auto btn"
              >
                <BsPlus className="text-xl mt-0.5" /> Satır Ekle
              </button>
            </div>
          )}
        </div>
        <div className="space-x-12 col-span-3 flex flex-col items-center">
          <div className="space-x-4">
            <button
              type="button"
              onClick={() =>
                section.table.rows.length > 0 ? deleteTable(i) : addTable(i)
              }
              className="btn bg-purple-600 text-white px-4 py-2 rounded mt-2 w-max mx-auto"
            >
              {section.table.rows.length > 0 ? "Tabloyu Sil" : "Tablo Ekle"}
            </button>
          </div>
          <button
            type="button"
            onClick={() => removeSection(i)}
            className="bg-red-600 text-white px-4 py-2 mx-auto rounded mt-3 flex items-center gap-1 w-max self-end"
          >
            <MdDelete /> Bölümü Sil
          </button>
        </div>
      </div>
    </div>
  );
};

export default BossUpdatesInput;
